import { ApiRequestError } from '../api/client';

/** TanStack Query's `queries.retry` predicate (wired in main.tsx's QueryClient
 * construction). Extracted so it's unit-testable without spinning up a
 * QueryClient. Skips retrying a 401 entirely — a dead/expired Cognito token
 * (2026-09-18 bug: a tab held a token that had expired weeks earlier) fails the
 * same way on every retry, so retrying just multiplies useless requests while
 * src/auth/sessionExpiry.ts's redirect-to-sign-in handles the actual recovery.
 * Everything else keeps the previous flat `retry: 1` policy. */
export function shouldRetryQuery(failureCount: number, error: Error): boolean {
  if (error instanceof ApiRequestError && error.status === 401) return false;
  return failureCount < 1;
}
